import {NotesEventTypes} from "../eventBus/notes/NotesEventTypes";
import Segment from "../../models/view/lessonPage/Segment";
import {subscribeToNotesEvents} from "../eventBus/notes/notesEventBus";
import {SegmentModeEnum} from "../../models/view/lessonPage/SegmentModeEnum";
import IVideoScore from "../../models/scorer/IVideoScore";
import {emitVideoScoring_completed} from "../eventBus/scorer/scorerEventBus";
import {logger} from "../log/logger";

class VideoScorer{
  unsubscribeFuncs: (() => void)[];
  segment?: Segment;
  scoringStartTime: number;
  constructor() {
    this.unsubscribeFuncs = [
      subscribeToNotesEvents(this.handleNotesEvent.bind(this)), //listen for when playback starts and ends so we can begin scoring.
    ];
  }

  handleNotesEvent(e: NotesEventTypes){
    switch (e.type) {
      case "playbackStarted":
        return this.beginScoring(e.segment);
      case "playback_reset": // fall through to playback_ended
      case "playback_ended":
        return this.endScoring();
    }
  }

  async beginScoring(segment: Segment){
    if(!segment.hasVideo || ( !(segment.mode === SegmentModeEnum.play || segment.mode === SegmentModeEnum.time || segment.mode === SegmentModeEnum.followAlong)) ){
      return logger.lessonScorerVideo.debug({message: `videoScorer only handles scoring video only segments`});
    }
    logger.lessonScorerVideo.debug({message: `videoScorer beginScoring`});
    this.segment = segment;
    this.scoringStartTime = Date.now();
  }

  async endScoring(){
    if(!this.segment){
      return logger.lessonScorerVideo.debug({message: `videoScorer was not scoring.  Probably a segment without video only`});
    }
    logger.lessonScorerVideo.debug({message: `videoScorer endScoring`});
    const durationMs = Date.now() - this.scoringStartTime;
    const videoScore: IVideoScore ={
      durationMs,
      date: Math.round(this.scoringStartTime / 1000),
      segmentId: this.segment.id,
      lessonId: this.segment.lessonId,
      hands: this.segment.hands,
      segmentMode: this.segment.mode,
    };

    this.segment = undefined;
    this.scoringStartTime = -1;

    emitVideoScoring_completed(videoScore);
  }
}

const videoScorer = new VideoScorer();
export default videoScorer;